package tta.destinigo.talktoastro.feature_profile.transaction_history.persentation



sealed class TransactionHistoryEvent {
    data object onBackButtonClick: TransactionHistoryEvent()
}